<template>
    <div class="payment-buttons">
        <h2>Payment Method</h2>
        <small>Please choose how you would like to pay:</small>
        <div class="inner">
            <a v-for="gateway in gateways" class="list-group-item" :class="'gateway-' + gateway.gateway_id" @click.prevent="ent(gateway)">
                {{  trans('payment_' + gateway.gateway_id) }}
            </a>
        </div>
        <paypal v-if="entity === 'PayPal_Express'" :public_id="public_id"></paypal>
        <eway v-if="entity === 'Eway_Rapid'" :public_id="public_id"></eway>
        <BankTransfer v-if="entity === 'BankTransfer'" :public_id="public_id"></BankTransfer>
        <div v-if="error" class="alert alert-danger">{{ error }}</div>
    </div>
</template>
<script>
    export default {
        props: {
            gateways: { default: [] },
//            gateway_url: { default: '' }
        },
        data: function() {
            return {
                public_id: '',
                entity: '',
                error: false
            }
        },
        components: {
            'paypal': require('./client/paypal.vue').default,
            'eway': require('./client/eway.vue').default,
            'BankTransfer': require('./client/bank-transfer.vue').default
        },
        created(){
            this.$eventHub.$on('setPaymentGateways', this.setData);
            this.$eventHub.$on('setPaymentError', this.setError);
        },
        methods: {
            setError(error) {
                this.error = error;
            },
            ent(gateway) {
                this.entity = gateway.gateway_id;
                this.public_id = gateway.public_id;
               /* this.axios.get(this.gateway_url, { params: {
                    public_id: gateway.public_id
                }}).then((response) => {
                    let data  = response.data;
                    if (typeof data.url !== 'undefined') {
                        window.location = response.data.url;
                    }
                    // do something
                    console.log(response);
                }).catch((error) => {
                    console.log(error);
                });*/

            }
        }
    }
    $('body').on('click', '.inner .list-group-item', function (e) {
        $(this).addClass('active');
        $(this).siblings().removeClass('active');
    });

</script>
